/* RESPONSIBLE TEAM: team-automation-foundations */
import { buildValidations, validator } from 'ember-cp-validations';
import Step from 'embercom/models/operator/visual-builder/step';
import { fragment } from 'ember-data-model-fragments/attributes';
import type Store from '@ember-data/store';
import { TargetContext } from 'embercom/objects/operator/configuration/custom-bot';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';

const Validations = buildValidations({
  action: [
    validator('presence', true),
    validator('rule-action-is-valid', {
      message: 'operator.workflows.visual-builder.validations.empty-action-error',
    }),
  ],
});

export default class ApplyConversationSla extends Step.extend(Validations) {
  @fragment('rules/rule-action') declare action: any;

  get supportedChannels() {
    return SUPPORTED_CHANNELS.applyConversationSla;
  }

  static get supportedContexts() {
    return [
      TargetContext.Conversation,
      TargetContext.CustomerTicket,
      TargetContext.BackOfficeTicket,
      TargetContext.TrackerTicket,
    ];
  }

  static get requiredBillingFeature() {
    return 'inbox_conversation_sla_rules';
  }

  static createNewStep(store: Store): ApplyConversationSla {
    return store.createRecord('operator/visual-builder/step/apply-conversation-sla', {
      action: store.createFragment('rules/rule-action', {
        type: 'apply-conversation-sla',
        justAdded: true,
      }),
      type: 'operator/visual-builder/step/apply-conversation-sla',
    });
  }
}
